import { Box, Image, Text } from '@chakra-ui/react'
import React from 'react'
import pic from"./assests/me.png"
const About = () => {
  return (
    <Box mb="50px" w="80%" data-testid="about" className='about section' id="about" pt={["70px"]} align="center" >
           <Text  
              fontWeight="bold" 
              fontSize={["35px", "35px", "55px"]}
              >
              About Me
              </Text>

              <Box pt={["70px"]} justifyItems="center" alignItems="center"  display={["block","block","flex"]} >
                    <Text w={["95%","80%","80%"]} 
                    fontSize={[null,"15px","20px"]}
                  //   mt={["20px","40px","150px"]}
                    align="left"
                    ml={[null,null,"30px"]}
                    textAlign="justify"
                    id="user-detail-intro"
                    >
                        A motivated and disciplined Full-Stack Web Developer with strong
            problem-solving skills and a passion for learning new technologies.
            Proficient in front-end technologies like HTML, CSS, JavaScript,

            TypeScript, React, Redux, Tailwind CSS, and Material-UI, and back-
            end skills like Node-js, express-js, and MongoDB. Eager to further

            develop skills as a full-stack MERN developer and build scalable
            websites. 

                    </Text>


                    <Box >
                          <Image className='home-img'  w="70%" src={pic} alt="me" />
                    </Box>


              </Box>

    </Box>
  )
}

export default About
